import * as React from 'react';
import '../index.css';
import {
  Arrow, Bookmark, Cart, Charge, Chevron,
  Close, Contact, Coupon, DoubleArrow, Erasing, Event, Fonts,
  Forward, Garbage, Home, Info, Lecture, LetterB, LetterE,
  LetterM, LetterR, LetterW, Lock, Logout, MainVA, Menu, MyNote,
  MyScore, Note, Notice, Number5, Password, Pause, Play, Question,
  QuestionMark, Reset, Rewind, Search, Secure, Setting, SignIn,
  SpecialOffer, Study, Terms, Tune, User
} from '@riiid/santa-closet-web/icons';
import withStyles from "react-jss";
import Highlight from "react-highlight";

const styles = {
  wrap: {
    '& h3': {
      margin: {
        top: 30,
        left: 5
      }
    },
    '& .set': {
      display: 'flex',
      flexDirection: 'column',
      textJustify: 'center',
      justifyContent: 'center',
      width: 100,
    }
  },
  content: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  set: {
    display: 'flex',
    flexDirection: 'column',
    width: 100,
    margin: '10px 4px',
    float: 'left',
    '& .title': {
      margin: {
        top: 10
      }
    }
  }
};

const StyledIconSet = ({classes, icon, title}) => {
  return (
    <div className={classes.set}>
      {icon}
      <span className="title">{title}</span>
    </div>
  )
};
const IconSet = withStyles(styles)(StyledIconSet);

const StyledIcons = ({classes}) => {
  return (
    <div className={classes.wrap}>
      <h3 className={classes.title}>Type</h3>
      <div className={classes.content}>
        <IconSet icon={<Cart width={100}/>} title="solid(default)"/>
        <IconSet icon={<Cart width={100} type="line"/>} title="line"/>
      </div>
      <h3 className={classes.title}>List</h3>
      <div className={classes.content}>
        <IconSet icon={<Arrow width={100}/>} title="Arrow"/>
        <IconSet icon={<Bookmark width={100}/>} title="Bookmark"/>
        <IconSet icon={<Cart width={100}/>} title="Cart"/>
        <IconSet icon={<Charge width={100}/>} title="Charge"/>
        <IconSet icon={<Chevron width={100}/>} title="Chevron"/>
        <IconSet icon={<Close width={100}/>} title="Close"/>
        <IconSet icon={<Contact width={100}/>} title="Contact"/>
        <IconSet icon={<Coupon width={100}/>} title="Coupon"/>
        <IconSet icon={<DoubleArrow width={100}/>} title="DoubleArrow"/>
        <IconSet icon={<Erasing width={100}/>} title="Erasing"/>
        <IconSet icon={<Event width={100}/>} title="Event"/>
        <IconSet icon={<Fonts width={100}/>} title="Fonts"/>
        <IconSet icon={<Forward width={100}/>} title="Forward"/>
        <IconSet icon={<Garbage width={100}/>} title="Garbage"/>
        <IconSet icon={<Home width={100}/>} title="Home"/>
        <IconSet icon={<Info width={100}/>} title="Info"/>
        <IconSet icon={<Lecture width={100}/>} title="Lecture"/>
        <IconSet icon={<LetterB width={100}/>} title="LetterB"/>
        <IconSet icon={<LetterE width={100}/>} title="LetterE"/>
        <IconSet icon={<LetterM width={100}/>} title="LetterM"/>
        <IconSet icon={<LetterR width={100}/>} title="LetterR"/>
        <IconSet icon={<LetterW width={100}/>} title="LetterW"/>
        <IconSet icon={<Lock width={100}/>} title="Lock"/>
        <IconSet icon={<Logout width={100}/>} title="Logout"/>
        <IconSet icon={<MainVA width={100}/>} title="MainVA"/>
        <IconSet icon={<Menu width={100}/>} title="Menu"/>
        <IconSet icon={<MyNote width={100}/>} title="MyNote"/>
        <IconSet icon={<MyScore width={100}/>} title="MyScore"/>
        <IconSet icon={<Note width={100}/>} title="Note"/>
        <IconSet icon={<Notice width={100}/>} title="Notice"/>
        <IconSet icon={<Number5 width={100}/>} title="Number5"/>
        <IconSet icon={<Password width={100}/>} title="Password"/>
        <IconSet icon={<Pause width={100}/>} title="Pause"/>
        <IconSet icon={<Play width={100}/>} title="Play"/>
        <IconSet icon={<Question width={100}/>} title="Question"/>
        <IconSet icon={<QuestionMark width={100}/>} title="QuestionMark"/>
        <IconSet icon={<Reset width={100}/>} title="Reset"/>
        <IconSet icon={<Rewind width={100}/>} title="Rewind"/>
        <IconSet icon={<Search width={100}/>} title="Search"/>
        <IconSet icon={<Secure width={100}/>} title="Secure"/>
        <IconSet icon={<Setting width={100}/>} title="Setting"/>
        <IconSet icon={<SignIn width={100}/>} title="SignIn"/>
        <IconSet icon={<SpecialOffer width={100}/>} title="SpecialOffer"/>
        <IconSet icon={<Study width={100}/>} title="Study"/>
        <IconSet icon={<Terms width={100}/>} title="Terms"/>
        <IconSet icon={<Tune width={100}/>} title="Tune"/>
        <IconSet icon={<User width={100}/>} title="User"/>
      </div>
      <Highlight language="javascript" className="code-block">
        {`import {Cart} from '@riiid/santa-closet-web/icons';

  export class Example extends Component {
    render () {
      return (
        <Cart/>
        <Cart width={100} height={100} fill="#333" type="line"/>
      )
    }
  }`}
      </Highlight>
    </div>
  )
};

const Icons = withStyles(styles)(StyledIcons);

export default Icons;



// WEBPACK FOOTER //
// ./src/components/Icons.js